import { useContext } from 'react'

import { TimeZone } from '../context'

/**
 * @returns {string | null}
 */
export function useTimeZone() {
  return useContext(TimeZone)
}
